module.exports = __webpack_public_path__ + "static/img/jiafei.c64892de.svg";